module.exports = __webpack_public_path__ + "img/discard_silo_img3.47898caf.jpeg";